import { Box, Typography } from "@mui/material";
import type { Bank } from "Infrastructure/Api/Api";
import { Trans } from "react-i18next";
import {
  Resources,
  useResource,
  getResourcePath,
} from "Translations/Resources";

type Props = {
  bank: Bank;
};

export const HowToConnect = ({ bank }: Props) => {
  const { t } = useResource();

  return (
    <Box>
      <Typography component="h2" variant="body1" fontWeight="500">
        {t(Resources.BankRating.Detail.Titles.HowToConnect)}
      </Typography>
      <Typography>
        <Trans
          i18nKey={getResourcePath(
            Resources.BankRating.Banks[bank].HowToConnect,
          )}
          components={{
            linebreak: <br />,
            bold: <strong />,
          }}
        />
      </Typography>
    </Box>
  );
};
